<template>
  <va-edit-layout>
    <pathologies-form :id="id" :title="title" :item="item"></pathologies-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
